/**
 * Location / Site terminology helper.
 *
 * Default wording is "Location" (plural: "Locations"). Businesses can enable
 * `use_site_terminology` to use "Site" / "Sites" instead.
 *
 * Asset home-location fields use "Home Location" separately — see AssetManagement.
 *
 * Sidebar labels (nav_locations, nav_location_checks) are resolved separately via
 * admin UI labels — custom values from the label editor always win.
 */

export interface LocationLabelOptions {
  plural?: boolean;
  lowercase?: boolean;
}

export function locationLabel(useSite: boolean, options: LocationLabelOptions = {}): string {
  const { plural = false, lowercase = false } = options;
  let word: string;
  if (useSite) {
    word = plural ? 'Sites' : 'Site';
  } else {
    word = plural ? 'Locations' : 'Location';
  }
  if (lowercase) word = word.toLowerCase();
  return word;
}

/** Convenience for "Location Checks" / "Site Checks" style headings. */
export function locationChecksLabel(useSite: boolean): string {
  return `${locationLabel(useSite)} Checks`;
}
